import { FC, useEffect, useState } from "react";
import { CSelect, CSelectProps } from ".";
import { useTranslation } from "react-i18next";
import { useGetProperties } from "service/property";
import { IPropertyParams } from "service/property/interface";

export interface CSelectPropertyAllProps extends CSelectProps {
  params?: IPropertyParams;
}

export const CSelectPropertyAll: FC<CSelectPropertyAllProps> = ({
  placeholder,
  params,
  ...props
}) => {
  const { t } = useTranslation();
  const { data, isFetching } = useGetProperties(params);

  return (
    <CSelect
      {...props}
      placeholder={placeholder ? placeholder : t("property", { ns: "menu" })}
      valueOption={{
        values: data?.data || [],
        valueKey: "uuid",
        labelKey: "nameTh",
      }}
      loading={isFetching}
      filterOption={(value, option) => {
        const filterSearch = !!option?.label
          ?.toString()
          ?.toLowerCase()
          ?.includes(value.toLowerCase());
        return filterSearch;
      }}
    />
  );
};
